module.exports = __webpack_public_path__ + "26d6dfe9083fc029a971623a42ae9a24.svg";